import { Button, cn } from "@devhop/ui";
import { ShoppingCart } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useCartSheet } from "../context/CartSheetContext";
import { useCartAddPulse } from "../hooks/useCartAddPulse";

type CartFloatingButtonProps = {
  className?: string;
};

export function CartFloatingButton({ className }: CartFloatingButtonProps) {
  const { itemCount } = useCart();
  const { open } = useCartSheet();
  const isPulsing = useCartAddPulse();

  return (
    <Button
      size="lg"
      className={cn(
        "fixed right-4 z-50 h-14 w-14 rounded-full shadow-lg transition-transform lg:hidden pos-cart-fab",
        isPulsing && "animate-cart-bounce",
        className,
      )}
      onClick={open}
      data-cart-target
    >
      <div className="relative">
        <ShoppingCart className="h-6 w-6" />
        {itemCount > 0 && (
          <span
            className={cn(
              "absolute -top-5 -right-5 flex h-5 w-5 items-center justify-center rounded-full bg-destructive font-bold text-destructive-foreground text-xs",
              isPulsing && "animate-cart-bounce",
            )}
          >
            {itemCount > 99 ? "99+" : itemCount}
          </span>
        )}
      </div>
    </Button>
  );
}
